import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Dashboard.css';
import DashboardNav from 'components/admin/dashboard/DashboardNav';
import DashboardRecentActivity from 'components/admin/dashboard/DashboardRecentActivity';
import ChatActivity from 'components/admin/chats/ChatActivity';

class Dashboard extends Component {
  render() {
    return (
      <div className="dashboard">
        <div className="dashboard-content">
          <DashboardNav />
          <div className="dashboard-activity">
            <div className="dashboard-recent-activity">
              <DashboardRecentActivity />
            </div>
            <div className="dashboard-chat-activity">
              <ChatActivity />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/Dashboard.js